/**
 * Client-side environment detection from the browser URL.
 * Used so Dev / Test / Prod look visually different (theme preset).
 */

export const TEST_HOSTNAMES = ['test.futurefocusonline.com'];

/** Mantis preset for Test — distinctive vs Prod theme7 green */
export const TEST_SITE_PRESET_COLOR = 'theme5';

export const DEV_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]', 'ffdp3.loc'];

/** Mantis preset for local / Dev VM — Ant Design default blue */
export const DEV_SITE_PRESET_COLOR = 'default';

/**
 * @param {string} [hostname]
 * @returns {boolean}
 */
export function isTestSite(hostname) {
  const host = String(hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return TEST_HOSTNAMES.includes(host);
}

/**
 * Local Vite (`localhost`) and the Dev VM (`ffdp3.loc`).
 * Test hostname wins if both could match (they cannot in practice).
 *
 * @param {string} [hostname]
 * @returns {boolean}
 */
export function isDevSite(hostname) {
  const host = String(hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  return DEV_HOSTNAMES.includes(host);
}

/**
 * Hostname-forced theme preset. Null means use config / localStorage (Prod theme7).
 *
 * @param {string} [hostname]
 * @returns {'theme5' | 'default' | null}
 */
export function getForcedPresetColor(hostname) {
  if (isTestSite(hostname)) return TEST_SITE_PRESET_COLOR;
  if (isDevSite(hostname)) return DEV_SITE_PRESET_COLOR;
  return null;
}

/**
 * Visual brand key for logo / favicon / login splash.
 *
 * @param {string} [hostname]
 * @returns {'test' | 'dev' | 'prod'}
 */
export function getSiteBrand(hostname) {
  if (isTestSite(hostname)) return 'test';
  if (isDevSite(hostname)) return 'dev';
  return 'prod';
}
